import React, { useContext } from "react";
import { UserContext } from "./UserContext";

const ProfileData = () => {
    const { user } = useContext(UserContext);
    const displayRole = user?.role?.toLowerCase()?.includes("user") ? "User" : user?.role;

    return (
        <React.Fragment>
            {user?.image && <img src={user?.image} className="ProfileImg" alt="Profile" style={{ size: "25px", borderRadius: "50%", marginTop:"-12px" }} />}
            <p className="mt-2">
                {/* {`${user?.name || ""},`} {displayRole || ""} */}
                {`${user?.name?.split(" ")[0] || ""},`} {displayRole || ""}
            </p>
        </React.Fragment>
    );
};

export default ProfileData;
